// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2rXLt","left":"StickyBox_left__2AMg6","right":"StickyBox_right__1xUnb"};